var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTab from '@material-ui/core/Tab';
/**
 * Kareo wrapped component of the Material-UI Tab. The prop API has been limited to props defined in TabProps.
 *
 * Material-UI Tab: [Docs](https://v4.mui.com/components/tabs/), [API](https://v4.mui.com/api/tab/)
 *
 * @storybook: [Tab](http://design.kareoprod.ent/design-system/?path=/docs/components-navigation--tabs-example)
 */
var Tab = React.forwardRef(function (props, ref) { return (React.createElement(MuiTab, __assign({}, props, { ref: ref, textColor: "primary" }))); });
Tab.defaultProps = {};
Tab.displayName = 'KareoTab';
export default Tab;
